<template>
  <div>
    <div class="dog-container">
      <!-- Iframe per caricare la pagina statica -->
      <iframe src="/dog.html" frameborder="0" class="dog-iframe"></iframe>
    </div>
    <div id="say-yes">
      <h1 style="padding-left: 10px; padding-right: 10px">{{ question }}</h1>
      <h2>{{ description }}</h2>
      <div class="contaner-buttons">
        <el-button @mouseenter="saidNo()" :style="isHover ? 'position: absolute' : ''" @click="saidNo()"
          class="no-button" type="danger">NO</el-button>
        <el-button class="yes-button" @click="saidYes()" type="primary">SI</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase"

export default {
  name: 'SayYes',
  components: {
  },
  props: {
  },
  data() {
    return {
      b: null,
      isHover: false,
      isAnswered: false,
    }
  },
  mounted() {
    if (!this.isLogged) {
      this.$router.push({ name: "secretWord" })
    }
    this.b = document.querySelector("button");
  },
  computed: {
    ip() {
      return this.$store.state.ip
    },
    isLogged() {
      return this.$store.state.isLogged
    },
    question() {
      return process.env.VUE_APP_PROJECT_QUESTION
    },
    description() {
      console.log(process.env.VUE_APP_PROJECT_QUESTION_DESCRIPTION)
      return process.env.VUE_APP_PROJECT_QUESTION_DESCRIPTION
    }
  },
  methods: {
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    saidYes() {
      if (!this.isAnswered) {
        var collection = firebase.firestore().collection(process.env.VUE_APP_FIREBASE_PROJECT_TITLE)
        var date = new Date()
        var fullYearDate = date.getFullYear() + "-" + date.getUTCMonth() + "-" + date.getDate()
        collection.doc("entered").collection("/" + fullYearDate).add({
          ip: this.ip,
          date: date,
          orderDate: fullYearDate,
          isMobile: this.isMobile(),
          response: true,
          userAgent: navigator.userAgent
        })

        this.isAnswered = true
      }
      this.$message({
        showClose: true,
        message: 'Grazie per aver risposto SI! ❤️',
        type: 'success'
      })
    },
    saidNo() {
      this.isHover = true

      var maxWidth = window.innerWidth - this.b.offsetWidth; // Evita che il pulsante esca dallo schermo
      var maxHeight = window.innerHeight - this.b.offsetHeight; // Evita che il pulsante esca dallo schermo

      var i = Math.floor(Math.random() * maxWidth);
      var j = Math.floor(Math.random() * maxHeight);
      this.b.style.left = i + "px";
      this.b.style.top = j + "px";
    }
  }
}
</script>

<style lang="less">
#say-yes {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2; /* Porta il contenuto sopra il background */

  h1 {
    font-size: 2rem;
    margin-bottom: 1rem;
  }

  .contaner-buttons {
    display: flex;

    .no-button {
      display: block;
    }

    .yes-button {
      margin-left: 30px;
    }
  }
}

.dog-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1; /* Posiziona il contenitore dietro il contenuto */
  overflow: hidden;

  .dog-iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>